define((require) => {
    "use strict";

    const Browser = require("shared/services/Browser");

    /**
     * @private @type {String}
     * Prefix to any cookie name stored as this class may be run at the client domain, i.e. in
     * DnD or the viewer. We do not want to conflict with any existing keys there.
     */
    const NAME_PREFIX = "zmags_"; // someprefix + underscore seems to be the cookie naming convention!

    /**
     * Class containing all static methods for handling cookies. <p>
     *
     * Note: all cookies are by default stored as "Secure" if and only if on a secure url/connection, i.e. not sent
     *       along with http requests, as the API is stateless. They cannot be marked as secure on non https, as they
     *       will be impossible to read via Javascript then.
     *
     * @author Bo Gotthardt (borrowed from http://www.quirksmode.org/js/cookies.html)
     *
     * @see  http://resources.infosecinstitute.com/securing-cookies-httponly-secure-flags/
     *
     * @class Cookie
     */
    return {

        /**
         * Set a cookie with the specified name and value. Overwrites the value if it already exists.
         *
         * @param {String} name the name
         * @param {String} value the value
         * @param {Number} [hours=87600] the number of days the cookie should be stored, 0 for the current session only
         */
        set(name, value, hours) {
            let expires = "";
            let postfix = "; path=/";

            if (hours === undefined) {
                hours = 3650 * 24;  // 10 years
            }
            if (hours) {
                const date = new Date();
                date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
                expires = `; expires=${date.toGMTString()}`;
            }
            if (Browser.capabilities.isSecure) {
                postfix += "; Secure";
            }
            window.document.cookie = `${NAME_PREFIX}${name} = ${value}${expires}${postfix}`;
        },

        /**
         * Get the value of the cookie with the specified name, or null if it does not exist.
         *
         * @param {String} name the name
         * @return {String} the cookie value, or null
         */
        get(name) {
            return this._get(NAME_PREFIX + name) || this._get(name);  // TODO: legacy issue without prefix, remove eventually
        },

        _get(name) {
            const nameEQ = `${name}=`;
            const ca = window.document.cookie.split(";");

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },

        /**
         * Remove the cookie with the specified name.
         *
         * @param {String} name the name
         */
        remove(name) {
            this.set(name, "", -1);
        }

    };
});



// WEBPACK FOOTER //
// ./src/editor/util/Cookie.js